jQuery(document).ready(function ($) {
  var $menu = $('#mobile-menu');

  if (!$menu.length) {
    return;
  }

  function closeAllMobileSubmenus() {
    $menu.find('.menu-item-wrapper.open').each(function () {
      var $openWrapper = $(this);
      $openWrapper.removeClass('open');
      $openWrapper.find('.toggle-submenu').attr({
        'aria-expanded': 'false',
        'aria-label': 'Untermenü öffnen',
      });
      $openWrapper.siblings('.sub-menu').removeClass('open');
    });
  }

  $menu.find('.menu-item-has-children').each(function () {
    var $item = $(this);
    var $link = $item.children('a').first();
    var $submenu = $item.children('.sub-menu').first();

    if (!$link.length || !$submenu.length || $item.children('.menu-item-wrapper').length) {
      return;
    }

    $link.wrap('<div class="menu-item-wrapper"></div>');
    var $wrapper = $item.children('.menu-item-wrapper');

    var submenuId = $submenu.attr('id');
    if (!submenuId) {
      submenuId = 'mobile-submenu-' + $item.attr('id');
    }
    if (!submenuId) {
      submenuId = 'mobile-submenu-' + Math.random().toString(36).slice(2);
      $submenu.attr('id', submenuId);
    }

    var $toggle = $(
      '<button type="button" class="toggle-submenu" aria-expanded="false" aria-controls="' +
        submenuId +
        '" aria-label="Untermenü öffnen"></button>'
    );

    $wrapper.append($toggle);

    $toggle.on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var isOpen = $wrapper.hasClass('open');

      $menu.find('.menu-item-wrapper.open').not($wrapper).each(function () {
        var $openWrapper = $(this);
        $openWrapper.removeClass('open');
        $openWrapper.find('.toggle-submenu').attr({
          'aria-expanded': 'false',
          'aria-label': 'Untermenü öffnen',
        });
        $openWrapper.siblings('.sub-menu').removeClass('open');
      });

      $wrapper.toggleClass('open', !isOpen);
      $submenu.toggleClass('open', !isOpen);
      $toggle.attr({
        'aria-expanded': !isOpen ? 'true' : 'false',
        'aria-label': !isOpen ? 'Untermenü schließen' : 'Untermenü öffnen',
      });
    });
  });

  function closeMobileMenu() {
    var $trigger = $('.component-menu-trigger');
    var $modal = $('.menu-modal');

    if (!$modal.hasClass('is-open') || !$trigger.hasClass('is-open')) {
      return;
    }

    closeAllMobileSubmenus();
    $trigger.trigger('click');
  }

  $menu.on('click', 'a', function () {
    closeMobileMenu();
  });

  $('.component-menu-trigger, .menu-modal-bg').on('click', function () {
    if ($('.menu-modal').hasClass('is-open')) {
      closeAllMobileSubmenus();
    }
  });
});
